import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Panel, Empty } from "@/components/PageHeader";
import { eur, num } from "@/lib/api";

const it = (v, d = 1) => (v ?? 0).toLocaleString("it-IT", { maximumFractionDigits: d });

const Uplift = ({ v }) => v == null ? <span className="text-slate-300">—</span> : (
  <span className={`font-mono text-xs ${v > 5 ? "text-emerald-600" : v < -5 ? "text-rose-600" : "text-slate-500"}`}>{v > 0 ? "+" : ""}{it(v)}%</span>
);

export const PromoTables = ({ data }) => {
  const single = data.scope.type === "customer";
  return (
    <div className="grid gap-6 xl:grid-cols-[1fr_1.6fr] [&>*]:min-w-0">
      <Panel title="Codici promozionali" testId="promo-codes-panel">
        {data.codes.length === 0 ? <Empty text="Nessuna promozione nel periodo." /> : (
          <div className="overflow-x-auto">
            <Table data-testid="promo-codes-table">
              <TableHeader><TableRow>
                <TableHead>Codice</TableHead><TableHead className="text-right">Vendite</TableHead><TableHead className="text-right">Sconto %</TableHead>
                <TableHead className="text-right">Scontrini</TableHead>{!single && <TableHead className="text-right">Clienti</TableHead>}
              </TableRow></TableHeader>
              <TableBody>
                {data.codes.map((c) => (
                  <TableRow key={c.code} data-testid="promo-code-row">
                    <TableCell><span className="rounded-md bg-blue-50 px-2 py-0.5 font-mono text-xs text-blue-700">{c.code}</span><div className="mt-1 text-[10px] text-slate-400">{it(c.share)}% delle vendite promo</div></TableCell>
                    <TableCell className="text-right font-mono text-xs">{eur(c.spend)}</TableCell>
                    <TableCell className="text-right font-mono text-xs">{it(c.discount_pct)}%</TableCell>
                    <TableCell className="text-right font-mono text-xs">{num(c.receipts)}</TableCell>
                    {!single && <TableCell className="text-right font-mono text-xs">{num(c.clients)}</TableCell>}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Panel>
      <Panel title="Prodotti in promozione: volume e conversione" testId="promo-products-panel">
        {data.products.length === 0 ? <Empty text="Nessun prodotto acquistato in promo." /> : (
          <div className="max-h-[560px] overflow-auto">
            <Table data-testid="promo-products-table">
              <TableHeader><TableRow>
                <TableHead>Prodotto</TableHead><TableHead className="text-right">Vendite promo</TableHead><TableHead className="text-right">Sconto %</TableHead>
                <TableHead className="text-right">Q.tà/riga promo vs pieno</TableHead><TableHead className="text-right">Uplift</TableHead>
                {single && <TableHead>Dopo la promo</TableHead>}
              </TableRow></TableHeader>
              <TableBody>
                {data.products.map((p) => (
                  <TableRow key={p.ean} data-testid="promo-product-row">
                    <TableCell><div className="text-sm font-medium text-slate-800">{p.name}</div><div className="font-mono text-[10px] text-slate-400">{num(p.promo_lines)} righe promo · {num(p.normal_lines)} a prezzo pieno{p.by_weight ? " · a peso" : ""}</div></TableCell>
                    <TableCell className="text-right font-mono text-xs">{eur(p.promo_spend)}</TableCell>
                    <TableCell className="text-right font-mono text-xs">{p.discount_pct ? `${it(p.discount_pct)}%` : "—"}</TableCell>
                    <TableCell className="text-right font-mono text-xs">{it(p.promo_qty_per_line, 2)} / {p.normal_lines ? it(p.normal_qty_per_line, 2) : "—"}</TableCell>
                    <TableCell className="text-right"><Uplift v={p.uplift_pct} /></TableCell>
                    {single && <TableCell>{p.converted
                      ? <span className="rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] text-emerald-700">Riacquistato a prezzo pieno</span>
                      : p.normal_lines
                        ? <span className="rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[11px] text-amber-700">Non riacquistato dopo la promo</span>
                        : <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] text-slate-500">Solo in promo</span>}</TableCell>}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Panel>
    </div>
  );
};
